import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { applyPageSeo } from "../lib/seo";

// Shared layout for standalone legal pages (Cookie Policy, Accessibility).
export const LegalLayout = ({ title, description, path, updated, testid, children }) => {
  useEffect(() => {
    applyPageSeo({ title: `${title} | Freeman Jones`, description, path });
  }, [title, description, path]);

  return (
    <section id="top" data-testid={testid} className="bg-brand-bg">
      <div className="mx-auto max-w-3xl px-4 py-14 lg:px-8 lg:py-20">
        <Link
          to="/"
          data-testid="legal-back-home"
          className="inline-flex min-h-[44px] items-center gap-2 rounded-full text-sm font-semibold text-brand-teal transition-colors hover:text-brand-tealHover"
        >
          <ArrowLeft className="h-4 w-4" aria-hidden="true" /> Back to homepage
        </Link>
        <h1
          data-testid="legal-heading"
          className="mt-6 font-heading text-4xl font-bold text-brand-navy sm:text-5xl"
        >
          {title}
        </h1>
        <p className="mt-3 text-sm text-brand-body/70">Last updated: {updated}</p>
        <div className="mt-10 space-y-10">{children}</div>
      </div>
    </section>
  );
};

export const LegalSection = ({ id, title, children }) => (
  <section aria-labelledby={id}>
    <h2 id={id} className="font-heading text-base font-bold text-brand-navy md:text-lg">
      {title}
    </h2>
    <div className="mt-3 space-y-3 text-base leading-relaxed text-brand-body">{children}</div>
  </section>
);
